exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".award-title[data-v-298e39c7] {\n  font-size: 2em;\n}\n.nav-pills a[data-v-298e39c7] {\n  font-size: 2em;\n}", ""]);

// exports
